import { ILiveGamesSubscription } from './types';

export const LIVE_GAME_IMAGE_UPDATE_INTERVAL = 20000;
export const SUBSCRIPTIONS_STORE: { subscriptions: ILiveGamesSubscription[] } = { subscriptions: [] };
